"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PureBody = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Constant = require("../Constant");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  font-family: ", ";\n  padding: 0;\n  margin: 0;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

// this component strips all margin and padding to be added as needed per page. Design would like to work toward a standard margin-bottom: 1rem; between paragraphs
var PureBody = _styledComponents.default.p.attrs(function (props) {
  return props;
})(_templateObject(), _Constant.Font.PRIMARY_FONT);
/**
 * Base body element, allowing to pass different semantic
 * elements to use as a base.
 *
 * PureBody defines common body styles,
 * BodyBase sets up passing a semantic element
 *
 * A specific Body, such as SmallBodyBold, consumes it,
 * and adds its specific styles.
 *
 * Example:
 *
 * export const SmallBodyBold = styled(BodyBase)`
 *   font-size: 1.3rem;
 *   font-weight: 600;
 * `;
 *
 * import * as Typography from 'components/Component/UI/Typography';
 *
 * <Typography.SmallBodyBold semanticElement="span">
 *   Hello
 * </Typography.SmallBodyBold>
 */


exports.PureBody = PureBody;

var BodyBase = function BodyBase(_ref) {
  var semanticElement = _ref.semanticElement,
      className = _ref.className,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["semanticElement", "className", "children"]);
  return /*#__PURE__*/_react.default.createElement(PureBody, (0, _extends2.default)({
    as: semanticElement,
    className: className
  }, rest), children);
};

BodyBase.propTypes = {
  /** Used to keep body component styles while rendering an HTML element besides a `p`.  */
  semanticElement: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node
};
BodyBase.defaultProps = {
  semanticElement: 'p',
  className: '',
  children: null
};
var _default = BodyBase;
exports.default = _default;